<div class="header">
  <div class="header__logo-block">
    <img class="inside-logo-block__logo" src="../../assets/images/logo.png" />
    <div class="inside-logo-block__title">Stotrasagar</div>
  </div>
  <div class="header__menu-block">
    <div *ngFor="let title of menu; let i = index">
      <a routerLink="{{ title.route }}" routerLinkActive="header-title-active">
        <header-title-cmp
            (click)="onTitleClick(i)"
            [isActive]="activeTitle"
            title="{{ title.title }}"
            total="{{ title.total }}"
            ></header-title-cmp>
      </a>
    </div>
  </div>
  <div class="header__logout-block">
    <a
        (click)="onOfferClick()"
        routerLink="/page/add-offer"
        routerLinkActive="header-icon-active"
        >
        <svg
            [ngStyle]="{ fill: activeTitle == 'offer' ? '#fb7e52' : '#ffffff' }"
            viewBox="0 0 512.003 512.003"
            class="header-icon"
            >
            <g>
          <g>
          <path
              d="M477.958,262.633c-2.06-4.215-2.06-9.049,0-13.263l19.096-39.065c10.632-21.751,2.208-47.676-19.178-59.023l-38.41-20.38 c-4.144-2.198-6.985-6.11-7.796-10.729l-7.512-42.829c-4.183-23.846-26.241-39.87-50.208-36.479l-43.053,6.09 c-4.647,0.656-9.242-0.838-12.613-4.099l-31.251-30.232c-17.401-16.834-44.661-16.835-62.061,0L193.72,42.859 c-3.372,3.262-7.967,4.753-12.613,4.099l-43.053-6.09c-23.975-3.393-46.025,12.633-50.208,36.479l-7.512,42.827 c-0.811,4.62-3.652,8.531-7.795,10.73l-38.41,20.38c-21.386,11.346-29.81,37.273-19.178,59.024l19.095,39.064 c2.06,4.215,2.06,9.049,0,13.263l-19.096,39.064c-10.632,21.751-2.208,47.676,19.178,59.023l38.41,20.38 c4.144,2.198,6.985,6.11,7.796,10.729l7.512,42.829c3.808,21.708,22.422,36.932,43.815,36.93c2.107,0,4.245-0.148,6.394-0.452 l43.053-6.09c4.643-0.659,9.241,0.838,12.613,4.099l31.251,30.232c8.702,8.418,19.864,12.626,31.03,12.625 c11.163-0.001,22.332-4.209,31.03-12.625l31.252-30.232c3.372-3.261,7.968-4.751,12.613-4.099l43.053,6.09 c23.978,3.392,46.025-12.633,50.208-36.479l7.513-42.827c0.811-4.62,3.652-8.531,7.795-10.73l38.41-20.38 c21.386-11.346,29.81-37.273,19.178-59.024L477.958,262.633z M196.941,123.116c29.852,0,54.139,24.287,54.139,54.139 s-24.287,54.139-54.139,54.139s-54.139-24.287-54.139-54.139S167.089,123.116,196.941,123.116z M168.997,363.886 c-2.883,2.883-6.662,4.325-10.44,4.325s-7.558-1.441-10.44-4.325c-5.766-5.766-5.766-15.115,0-20.881l194.889-194.889 c5.765-5.766,15.115-5.766,20.881,0c5.766,5.766,5.766,15.115,0,20.881L168.997,363.886z M315.061,388.888 c-29.852,0-54.139-24.287-54.139-54.139s24.287-54.139,54.139-54.139c29.852,0,54.139,24.287,54.139,54.139 S344.913,388.888,315.061,388.888z"
              />
          </g>
            </g>
      <g>
      <g>
      <path
          d="M315.061,310.141c-13.569,0-24.609,11.039-24.609,24.608s11.039,24.608,24.609,24.608 c13.569,0,24.608-11.039,24.608-24.608S328.63,310.141,315.061,310.141z"
          />
      </g>
      </g>
      <g>
      <g>
      <path
          d="M196.941,152.646c-13.569,0-24.608,11.039-24.608,24.608c0,13.569,11.039,24.609,24.608,24.609 c13.569,0,24.609-11.039,24.609-24.609C221.549,163.686,210.51,152.646,196.941,152.646z"
          />
      </g>
      </g>
        </svg>
    </a>
    <a
        (click)="onProfileClick()"
        routerLink="/page/profile"
        routerLinkActive="header-icon-active"
        >
        <svg 
        [ngStyle]="{ fill: activeTitle == 'profile' ? '#fb7e52' : '#ffffff' }"
        viewBox="0 0 24 24" class="header-icon">
          <path
              d="m22.683 9.394-1.88-.239c-.155-.477-.346-.937-.569-1.374l1.161-1.495c.47-.605.415-1.459-.122-1.979l-1.575-1.575c-.525-.542-1.379-.596-1.985-.127l-1.493 1.161c-.437-.223-.897-.414-1.375-.569l-.239-1.877c-.09-.753-.729-1.32-1.486-1.32h-2.24c-.757 0-1.396.567-1.486 1.317l-.239 1.88c-.478.155-.938.345-1.375.569l-1.494-1.161c-.604-.469-1.458-.415-1.979.122l-1.575 1.574c-.542.526-.597 1.38-.127 1.986l1.161 1.494c-.224.437-.414.897-.569 1.374l-1.877.239c-.753.09-1.32.729-1.32 1.486v2.24c0 .757.567 1.396 1.317 1.486l1.88.239c.155.477.346.937.569 1.374l-1.161 1.495c-.47.605-.415 1.459.122 1.979l1.575 1.575c.526.541 1.379.595 1.985.126l1.494-1.161c.437.224.897.415 1.374.569l.239 1.876c.09.755.729 1.322 1.486 1.322h2.24c.757 0 1.396-.567 1.486-1.317l.239-1.88c.477-.155.937-.346 1.374-.569l1.495 1.161c.605.47 1.459.415 1.979-.122l1.575-1.575c.542-.526.597-1.379.127-1.985l-1.161-1.494c.224-.437.415-.897.569-1.374l1.876-.239c.753-.09 1.32-.729 1.32-1.486v-2.24c.001-.757-.566-1.396-1.316-1.486zm-10.683 7.606c-2.757 0-5-2.243-5-5s2.243-5 5-5 5 2.243 5 5-2.243 5-5 5z"
              />
        </svg>
    </a>
    <a
        (click)="onLogoutClick()"
        routerLink="/login"
        routerLinkActive="header-icon-active"
        >
        <svg 
        [ngStyle]="{ fill: activeTitle == 'logout' ? '#fb7e52' : '#ffffff' }"
        class="header-icon" viewBox="0 0 469 469.33333">
          <path
              d="m234.832031 0c122.410157 0 222.804688 93.738281 233.601563 213.332031h-190.933594v-64c0-8.617187-5.207031-16.402343-13.164062-19.710937-7.976563-3.304688-17.152344-1.472656-23.25 4.628906l-85.335938 85.335938c-8.339844 8.339843-8.339844 21.820312 0 30.164062l85.335938 85.332031c6.097656 6.101563 15.273437 7.9375 23.25 4.628907 7.957031-3.304688 13.164062-11.09375 13.164062-19.710938v-64h190.933594c-10.796875 119.59375-111.191406 213.332031-233.601563 213.332031-129.597656 0-234.664062-105.066406-234.664062-234.664062 0-129.601563 105.066406-234.667969 234.664062-234.667969zm0 0"
              />
        </svg>
    </a>
  </div>
</div>
